const createAchPaymentStatus = (payment) => {
  if (!payment) {
    return '';
  }

  if (!payment.billcom_receivedpay_id && !payment.billcom_settlement_id) {
    return 'Not started';
  }

  if (
    payment.billcom_receivedpay_id &&
    !payment.billcom_settlement_id &&
    payment._billcom_settlement?._billcom_settlement_parent?.status
  ) {
    return payment._billcom_settlement?._billcom_settlement_parent?.status;
  }

  if (
    payment.billcom_receivedpay_id &&
    !payment.billcom_settlement_id &&
    !payment._billcom_settlement?._billcom_settlement_parent?.status
  ) {
    return payment.billcom_receivedpay_status;
  }

  if (payment.billcom_receivedpay_id && payment.billcom_settlement_id) {
    return payment._billcom_settlement?._billcom_settlement_parent?.status;
  }

  return '';
};

const createCheckPaymentStatus = (payment) => {
  if (!payment) {
    return '';
  }

  if (payment.status === 'void') {
    return 'Void';
  }

  if (payment.status === 'cancelled') {
    return 'Cancelled';
  }

  if (!payment.billcom_receivedpay_id && !payment.billcom_settlement_id) {
    return payment.check_cleared ? 'Cleared' : 'Pending';
  }

  if (payment.billcom_receivedpay_id && !payment.billcom_settlement_id) {
    return payment.check_cleared ? 'Cleared' : 'Pending';
  }

  if (payment.billcom_receivedpay_id && payment.billcom_settlement_id) {
    return payment.check_cleared ? 'Cleared' : 'Pending';
  }

  return '';
};

const createAchDirectPaymentStatus = (payment) => {
  if (payment.check_cleared) {
    return 'Cleared';
  }
  return 'Pending';
};

const createAchDirectBillPaymentStatus = (billPayment) => {
  if (!billPayment) {
    return '';
  }

  // For ACH direct bill payments, use the check_status field
  if (billPayment.check_status) {
    return billPayment.check_status;
  }

  return 'Pending';
};

const createAchBillPaymentStatus = (billPayment) => {
  if (!billPayment) {
    return '';
  }

  if (!billPayment.billcom_sentpay_id && !billPayment.billcom_settlement_id) {
    return 'Not started';
  }

  if (billPayment.billcom_sentpay_id && !billPayment.billcom_settlement_id) {
    return billPayment.billcom_sentpay_status;
  }

  if (!billPayment.billcom_sentpay_id && billPayment.billcom_settlement_id) {
    return billPayment.billcom_sentpay_status;
  }

  return billPayment.billcom_sentpay_status;
};

const createCheckBillPaymentStatus = (billPayment) => {
  // Handle Lob checks
  if (billPayment.check_use_lob) {
    if (!billPayment.check_id) {
      return 'Pending';
    }

    if (billPayment._check?.lob_status) {
      return billPayment._check.lob_status;
    }
  }

  // Handle Bill.com checks
  if (billPayment.check_use_billcom) {
    if (!billPayment.billcom_sentpay_id && !billPayment.billcom_settlement_id) {
      return billPayment.billcom_sentpay_status;
    }

    if (billPayment.billcom_sentpay_id && !billPayment.billcom_settlement_id) {
      return billPayment.billcom_sentpay_status;
    }

    if (!billPayment.billcom_sentpay_id && billPayment.billcom_settlement_id) {
      return billPayment.billcom_settlement.status;
    }

    return billPayment.billcom_sentpay_status;
  }

  // Default case for regular checks
  return billPayment.check_status;
};

export const createAchCheckPaymentStatus = (payment) => {
  if (!payment) {
    return '';
  }

  if (payment?.source === 'ACH') {
    return createAchPaymentStatus(payment);
  }
  if (payment?.source === 'Check') {
    return createCheckPaymentStatus(payment);
  }
  if (payment?.source === 'ACH direct') {
    return createAchDirectPaymentStatus(payment);
  }
  return '';
};

export const createAchCheckBillPaymentStatus = (billPayment) => {
  if (!billPayment) {
    return '';
  }

  if (billPayment.source === 'ACH') {
    return createAchBillPaymentStatus(billPayment);
  }
  if (billPayment.source === 'Check') {
    return createCheckBillPaymentStatus(billPayment);
  }
  if (billPayment.source === 'ACH direct') {
    return createAchDirectBillPaymentStatus(billPayment);
  }
  return '';
};
